const userRoles = ['admin', 'administrator', 'collaborator'];
const userTypes = ['free', 'premium'];

export const containsBackofficeRole = (roles) => {
  return roles.some(role => role.includes('backoffice'));
};

export const extractUserRole = (roles) => {
  return roles.find(role => 
    userRoles.some(validRole => role.includes(validRole))
  ) || null;
};

export const extractUserType = (roles) => {
  return roles.find(role => 
    userTypes.some(validType => role.includes(validType))
  ) || null;
};
